import styled from 'styled-components';
import { PROPER_CONTENT_WIDTH, BEFORE_MEDIUM_WIDTH, COLOR, PHONE_WIDTH } from './Const';

export const StyledTableWrapper = styled.div`
  display: block;
  width: 100%;
  margin: 2rem 0rem 3rem;
  font-size: 13px;

  &::-webkit-scrollbar {
    width: 2px;
  }

  table {
    width: 100%;
    border-spacing: 0;

    thead > tr {
      background-color: #ffffff;
      position: sticky;
      top: 0;
      z-index: 2;

      th {
        font-weight: 600;
        white-space: nowrap;
        &.sortable {
          cursor: pointer;
        }
      }

      &:last-child {
        border-bottom: 2px solid ${COLOR.home};
        th {
          padding: 0 0.2rem 0.5rem;
          &.infocus {
            border-bottom: 2px solid ${COLOR.primary};
          }
        }
      }

      small {
        font-size: 12px;
        font-weight: lighter;
      }
    }

    tbody {
      tr {
        border-bottom: 1px solid ${COLOR.home}80;
        background-color: #ffffff;
        &:nth-child(even) {
          background-color: #fafafa;
        }
      }

      td {
        padding: 0.5rem 0rem;
      }
    }

    th {
      &.infocus {
        background-color: ${COLOR.secondary};
        color: #ffffff;
      }
    }

    td {
      &.infocus {
        background-color: #dcdcdc;
      }
    }
  }

  @media (max-width: ${BEFORE_MEDIUM_WIDTH}) {
    margin: 1rem 0rem 2rem;
    font-size: 12px;
    table {
      table-layout: fixed;
    }
  }
`;

export const DisplayBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  margin: 0 auto;
  width: ${PROPER_CONTENT_WIDTH};
  max-width: 98%;
`;

export const StyledTab = styled.div`
  width: 98%;
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: flex-start;
  font-size: 1.6rem;
  font-weight: 600;
  color: #3a3a3a;
  letter-spacing: 2px;
  margin-bottom: 1.2rem;

  a {
    color: inherit;
  }

  .tab-name {
    opacity: 0.8;
    cursor: pointer;
    padding: 0.6rem 0.3rem;
    margin-right: 0.9rem;
    sub {
      color: #bcbcbc;
      font-size: 0.8rem;
    }
    &:hover {
      opacity: 1;
    }
    &.active {
      opacity: 1;
      font-size: 1.8rem;
      border-bottom: 5px solid rgb(195, 12, 12, 1);
    }
  }

  @media (max-width: ${PHONE_WIDTH}) {
    font-size: 1rem;
    .tab-name {
      &.active {
        font-size: 1.2rem;
      }
    }
  }
`;
